import {RefObject, useEffect, useState} from 'react'

import {StickyTo} from '..'

export const useFloating = (ref: RefObject<HTMLElement>, stickyTo: StickyTo): boolean => {
  const [isFloating, setIsFloating] = useState(false)

  useEffect(() => {
    const element = ref.current

    if (!element) {
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const {y} = entry.boundingClientRect

        setIsFloating(prevFloating => {
          if (stickyTo === StickyTo.BLOCK_END) {
            // Отслеживание соприкосновения наблюдаемого элемента только с верхней границей экрана
            return y - (entry.rootBounds?.height ?? 0) + entry.boundingClientRect.height > 0
          }

          if (stickyTo === StickyTo.BLOCK_START) {
            // Отслеживание соприкосновения наблюдаемого элемента только с нижней границей экрана
            return y < 0
          }

          return prevFloating
        })
      },

      {threshold: 1},
    )
    observer.observe(element)

    return () => {
      observer.unobserve(element)
    }
  }, [ref, stickyTo])

  return isFloating
}
